export default __webpack_public_path__ + "static/media/filter.ad6b6cca.svg";